<template>
  <div class="feed__main-container">
    <div class="feed__info-container">
      <Avatar 
        :text="feed.user.username.charAt(0)" 
        :avatarId="feed.userId"
        class="feed__avatar"
        :imgSrc="feed.user && feed.user.userable && feed.user.userable.photo ? `${photoBasePath}${feed.user.userable.photo.hashName}` : ''"
        :textSize="14" />
        <!-- {{ feed }} -->
      <div class="feed__info">
        <!-- <div class="feed__description">{{ feed.description }}</div>
        <div class="feed__sub-info">
          <div class="feed__sub-info-user"><v-icon name="user" height="8px" /> {{ feed.user.name }}</div>
          <div class="feed__sub-info-time"><v-icon name="calendar"  height="8px" />  {{ $options.format(new Date(feed.txnDate), 'EEE, MMM dd yyyy HH:mm aa') }}</div>
        </div> -->
        
        <div class="feed__description">{{ feed.message }}</div>
        <div class="feed__sub-info">
          <div class="feed__sub-info-user"><v-icon name="user" height="8px" /> {{ feed.user.username }}</div>
          <div class="feed__sub-info-time"><v-icon name="calendar"  height="8px" />  {{ $options.format(new Date(feed.createdAt), 'EEE, MMM dd yyyy HH:mm aa') }}</div>
        </div>
      </div>
    </div>
    

    <div class="divider"></div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import { format } from "date-fns";
export default {
  format,
  props: {
    feed: Object
  },
  components: {
    Avatar
  },
  data() {
    return {
      photoBasePath: `${process.env.VUE_APP_PUBLIC_PHOTO_URL}personnels/`
    }
  }
}
</script>

<style lang="scss" scoped>
  .feed__main-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    min-height: 65px;
    // padding: 5px 10px;
    margin: 3px 0;
  }

  .feed__main-container:nth-child(even) {
    background-color: rgb(226, 235, 250);
  }

  .feed__main-container:nth-child(odd) {
    background-color: whitesmoke;
  }
  
  .feed__info-container {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .divider {
    border-bottom: dotted 1px rgb(180, 177, 177);
    margin: 10px 0;
  }

  .feed__avatar {
    min-width: 50px;
    min-height: 50px;
  }

  .feed__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    width: 100%;

    .feed__description {
      font-size: 8pt;
      width: 100%;
    }
    .feed__sub-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 7pt;
      color: rgb(136, 134, 134);
      width: 100%;
      margin-top: 5px;
      .feed__sub-info-user {
        text-align: left;
      }
      .feed__sub-info-time {
        text-align: right;
      }
    }
  }

  @media screen and (max-width: 800px) {
    .feed__avatar {
      max-width: 5px!important;
      max-height: 5px!important;
    }
  }
</style>